import api from "@modules/JourneyBuilder/api";
import loadResourceString from "@core/Util/resources";

/**
 * Create a remote call loading the given campaigns and mapping them to dropdown options 
 * @param {function():Promise<{name: String, id: String|Number}[]>} fnLoadCampaigns
 * @returns {Promise<JourneyBuilder.DropdownOption[]>}
 */
async function createLoadCampaignOptionsCall(fnLoadCampaigns){
  const campaigns = await fnLoadCampaigns();
  
  return campaigns.map(campaign => ({
    label: campaign.name,
    id: campaign.id
  }));
}

/**
 * @type {Object.<String, JourneyBuilder.TouchpointCampaignType>}
 */
export default {
  emailCampaign: {
    getOptions: () => createLoadCampaignOptionsCall(api.getEmailCampaigns),
    icon: 'fas fa-envelope-open-text',
    propertyName: 'emailCampaign',
    get label(){
      return loadResourceString('JourneyBuilder_FilterSettings_SelectEmailCampaign')
    }
  },
  steamCampaign: {
    getOptions: () => createLoadCampaignOptionsCall(api.getSteamCampaigns),
    icon: 'fas fa-phone',
    propertyName: 'steamCampaign',
    get label(){
      return loadResourceString('JourneyBuilder_FilterSettings_SelectSteamCampaign')
    }
  },
  dmCampaign: {
    getOptions: () => createLoadCampaignOptionsCall(api.getDmCampaigns),
    icon: 'fas fa-envelope-open-text',
    propertyName: 'dmCampaign',
    get label(){
      return loadResourceString('JourneyBuilder_FilterSettings_SelectDmCampaign')
    }
  }
}